import { api } from './cliente.js';
import type { TransicaoDisponivel } from './tipos.js';

export type Urgencia = 'baixa' | 'media' | 'alta' | 'critica';
export type EstadoDemanda = 'Rascunho' | 'Submetida' | 'EmTriagem' | 'AprovadaMerito' | 'Rejeitada' | 'AutorizadaExecucao' | 'EmEspera' | 'Instanciada';

export interface Demanda {
  id: string;
  titulo: string;
  problema: string;
  beneficioEsperado: string;
  solicitante: string;
  areaImpactada: string | null;
  urgencia: Urgencia;
  esforcoEstimadoH: number | null;
  estado: EstadoDemanda;
  blueprintId: string | null;
  veredictoId: string | null;
  beneficioId: string | null;
  criadoPor: string;
  criadoEm: string;
}

export interface SubmeterDemandaInput {
  titulo: string;
  problema: string;
  beneficioEsperado: string;
  solicitante: string;
  areaImpactada?: string;
  urgencia: Urgencia;
  esforcoEstimadoH?: number;
}

export const demandasApi = {
  fila: () => api.get<Demanda[]>('/demandas/fila'),
  buscar: (id: string) => api.get<Demanda>(`/demandas/${id}`),
  transicoesDisponiveis: (id: string) => api.get<TransicaoDisponivel[]>(`/demandas/${id}/transicoes`),
  submeter: (input: SubmeterDemandaInput) => api.post<{ id: string }>('/demandas', input),
  triar: (id: string, blueprintId: string, notas: { criterio: string; nota: number }[]) => api.post(`/demandas/${id}/triagem`, { blueprintId, notas }),
  transicionar: (id: string, evento: string, justificativa?: string) => api.post(`/demandas/${id}/transicoes`, { evento, justificativa }),
  solicitarVeredicto: (id: string) => api.post(`/demandas/${id}/veredito`),
  autorizar: (id: string) => api.post(`/demandas/${id}/autorizar`),
  registrarOverride: (id: string, aprovadorSuperior: string, justificativa: string) => api.post(`/demandas/${id}/override`, { aprovadorSuperior, justificativa }),
};
